import { Icon } from '@livable/saas-react-components';
import { Button, Grid, Link, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { BuildingsTable } from 'src/components/property/BuildingsTable';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
export const EmptyState = observer(() => {
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.welcomeBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('dashboard_page.welcome_to_livable')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "light"
  }, t('dashboard_page.we_are_happy')), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('dashboard_page.welcome_instructions')))))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10,
    className: classes.actions,
    "data-tut": "reactour__actions"
  }, !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 4,
    xl: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "action",
    component: RouterLink,
    to: "/new_property",
    'custom-attribute': '530-dashboard-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building"
  }), t('add_new_property_flow.add_new_property'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 4,
    xl: true
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    to: "/file_cabinet?tab=manager_resources",
    variant: "action",
    'custom-attribute': '531-dashboard-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "folder-open"
  }), t('dashboard_page.files_to_get_started'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 4,
    xl: true
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    to: "/team_settings",
    variant: "action",
    'custom-attribute': '532-dashboard-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  }), t('dashboard_page.add_my_teammates'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 4,
    xl: true
  }, /*#__PURE__*/React.createElement(Button, {
    component: Link,
    href: "https://pm.livable.com/calculator",
    target: "_blank",
    variant: "action",
    'custom-attribute': '533-dashboard-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "calculator"
  }), t('dashboard_page.calculate_savings'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 4,
    xl: true
  }, /*#__PURE__*/React.createElement(Button, {
    component: Link,
    href: "https://pro.livable.com/knowledge",
    target: "_blank",
    variant: "action",
    'custom-attribute': '534-dashboard-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "question"
  }), t('dashboard_page.have_questions')))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(BuildingsTable, {
    buildingsData: []
  })));
});